import LazyLoad from "vanilla-lazyload";

window.lazyLoadInstance = new LazyLoad()

function updateLazyLoadInstance() {
  window.lazyLoadInstance.update()
}

document.addEventListener("turbo:load", updateLazyLoadInstance);
document.addEventListener("ajax:complete", updateLazyLoadInstance);
